import { ALERT_HIGHLIGHT_WINDOW_MS } from '@/stores';

export const NEW_ALERT_BORDER_GLOW = {
    hoverGlow: false,
    sweepDuration: ALERT_HIGHLIGHT_WINDOW_MS,
    edgeSensitivity: 30,
    // Parsed as HSL, not RGB.
    glowColor: '0 0 100',
    backgroundColor: '#1b1c1e',
    borderRadius: 10,
    glowRadius: 56,
    glowIntensity: 1,
    coneSpread: 25,
    colors: ['#ffffff'],
} as const;

export const BORDER_GLOW_CHROMELESS =
    '!border-transparent !shadow-none !bg-transparent';
